import { theme } from '@prose-ui';
import { legacyTheme, styled } from '@prose-ui/legacy';

import { Image } from 'Components/Image';
import { breakpoints } from 'Components/ThemeProvider';
import { Typography } from 'Components/Typography';

import ConsultationCTA from 'Containers/ConsultationCTA';

import journeyImage from 'assets/images/membership/prose-custom-haircare-skincare-trios.png';

import useMedia from 'utils/useMedia';

const ProspectJourneyWrapper = styled('div')({
  backgroundColor: theme.colors.primary[100],
  width: '100%',
  minHeight: 400,
  paddingTop: 66,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  [legacyTheme.breakpoints.up('lg')]: {
    flexDirection: 'row',
    paddingTop: 0,
    justifyContent: 'flex-end',
  },
});

const ImageWrapper = styled('div')({
  zIndex: 2,
  [legacyTheme.breakpoints.up('lg')]: {
    width: '50vw',
    height: 720,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
});

const StyledImage = styled(Image)({
  borderRadius: '50%',
  height: 300,
  width: 300,
  [legacyTheme.breakpoints.up('lg')]: {
    height: 500,
    width: 500,
  },
});

const RoundedBox = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  backgroundColor: theme.colors.primary[400],
  minHeight: 400,
  width: '100%',
  borderTopLeftRadius: 75,
  borderTopRightRadius: 75,
  marginTop: -150,
  padding: '175px 24px 81px',
  [legacyTheme.breakpoints.up('lg')]: {
    width: '50vw',
    height: 720,
    margin: 0,
    marginTop: 0,
    borderTopRightRadius: 0,
    borderBottomLeftRadius: 75,
    padding: '10%',
    justifyContent: 'center',
  },
});

const Intro = styled('p')({
  fontFamily: legacyTheme.typography.saol,
  fontSize: '28px',
  color: theme.colors.primary[400],
  lineHeight: 1.29,
  textAlign: 'center',

  [legacyTheme.breakpoints.up('lg')]: {
    color: theme.colors.neutral[100],
    fontSize: '36px',
  },
});

const IntroHighlight = styled('span')({
  fontFamily: legacyTheme.typography.simplonMono,
  fontSize: '28px',
  color: theme.colors.accent[300],
  textTransform: 'uppercase',
  fontWeight: 'bold',

  [legacyTheme.breakpoints.up('lg')]: {
    color: theme.colors.highlight[200],
  },
});

const JourneyBlock = () => {
  const isTablet = useMedia(`(max-width: ${breakpoints.lg - 1}px)`);
  const isMobile = useMedia(`(max-width: ${breakpoints.sm - 1}px)`);

  return (
    <ProspectJourneyWrapper>
      {(isTablet || isMobile) && (
        <>
          <Intro>
            Your journey starts <br /> <IntroHighlight>here</IntroHighlight>
          </Intro>
          <br />
        </>
      )}
      <ImageWrapper>
        <StyledImage alt="Prose custom haircare and skincare trios" src={journeyImage} />
      </ImageWrapper>
      <RoundedBox>
        {!(isTablet || isMobile) && (
          <>
            <Intro>
              Your journey starts <IntroHighlight>here</IntroHighlight>
            </Intro>
            <br />
          </>
        )}
        <Typography align="center" color="white" variant="p1">
          Great care has to be 3 things: consistent, convenient, and personal. With perfectly-timed
          deliveries of always-improving formulas, you’ll never miss a day of your routine. Expect
          your formulas to get new ingredients every season, and use Review & Refine<sup>®</sup> to
          get better-tailored care every order. With consistent custom care, the results build over
          time, revealing better hair every order—with no appointment necessary.
        </Typography>
        <br />
        {!isMobile && <ConsultationCTA label="begin yours here" theme="lime" />}
      </RoundedBox>
    </ProspectJourneyWrapper>
  );
};

export default JourneyBlock;
